import { makeVar } from '@apollo/client';

export const userAuthVar = makeVar(null);

export const categoriesVar = makeVar([]);

export const dataArrayVar = makeVar([]);
